<template>

    <component v-if="cell_item.component"
      :is="cell_item.component"
      :bus="bus"
      v-bind="cell_item.value">
      {{ cell_item.title_key }}
    </component>

    <span v-else :class="cell_item.customClasses || ''">
      {{ getDisplayValue(cell_item.value) }}
    </span>

</template>

<script>
  import ActionComponent from '@/components/layout/utility/ActionComponent'
  import StatusComponent from '@/components/layout/utility/StatusComponent'
  import ProgressBarComponent from '@/components/layout/utility/ProgressBarComponent'
  import LinkComponent from '@/components/layout/utility/LinkComponent'
  import ReportsCommentComponent from '@/components/layout/utility/ReportsCommentComponent'
  import DocumentsComponent from '@/components/layout/utility/DocumentsComponent'
  import FormFieldComponent from '@/components/form/field/FormFieldComponent'
  import ButtonComponent from '@/components/layout/utility/ButtonComponent'
  import DisconnectCustomerComponent from '@/components/layout/utility/DisconnectCustomerComponent'
  import FilesComponent from '@/components/layout/utility/FilesComponent'

  export default {
    name: 'table-cell-component',
    props: {
      cell_item: {
        type: Object,
        required: true
      },
      bus: {
        type: Object
      }
    },
    data: function () {
      return {}
    },
    components: {
      ActionComponent,
      StatusComponent,
      ProgressBarComponent,
      LinkComponent,
      ReportsCommentComponent,
      DocumentsComponent,
      FormFieldComponent,
      ButtonComponent,
      DisconnectCustomerComponent,
      FilesComponent
    },
    methods: {
      getDisplayValue (value) {
        if (!!value && value.constructor === Array) {
          return value.join(', ')
        }
        return value
      }
    }
  }
</script>
